import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';

export function UnbanPopover({
  name,
  hiddenCount,
  loading,
  defaultOpen = false,
  onConfirm,
}: {
  name: string;
  hiddenCount: number;
  loading?: boolean;
  defaultOpen?: boolean;
  onConfirm: () => Promise<void>;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const [busy, setBusy] = useState(false);
  const isBusy = loading || busy;
  const displayName = name || 'this person';

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" size="sm">
          Unban
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-3">
          <h3 className="font-semibold">Unban {displayName}?</h3>
          <p className="text-sm text-muted-foreground">
            {hiddenCount > 0
              ? `Their ${hiddenCount} hidden submission${hiddenCount === 1 ? '' : 's'} go back to your approval queue. Nothing goes back on screen automatically.`
              : "They'll be able to submit and vote on your screens again."}
          </p>
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="bg-background text-foreground"
              disabled={isBusy}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              type="button"
              size="sm"
              disabled={isBusy}
              onClick={async () => {
                setBusy(true);
                try {
                  await onConfirm();
                  setOpen(false);
                } finally {
                  setBusy(false);
                }
              }}
            >
              Unban
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
